import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 3,
    },
  },
});

declare module '@tanstack/react-query' {
  interface Register {
    // Broadened from AxiosError<ApiErrorData>: during the openapi-fetch
    // migration queries throw either an AxiosError (legacy) or an ApiError
    // (typed client). Consumers read messages via getApiErrorMessages(), which
    // handles both, so the error type stays the common Error supertype.
    defaultError: Error;
  }
}
